module.exports = __webpack_public_path__ + "static/media/blog_2.8ec0f542.jpg";